import React from 'react'
import { View, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'

import { Txt, Button } from '../../../components'
import KeyboardView from '../../../components/KeyboardView'
import { usePlatforms } from '../../../hooks/usePlatforms'
import { useTheme } from '../../../theming/ThemeProvider'
import InputFormik from '../../../components/InputFormik'
import * as Yup from 'yup'
import { Formik } from 'formik'

const validationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required')
})
function ForgotPasswordForm ({ loading, onForgotPassword }) {
  const { isTablet } = usePlatforms()
  const { theme } = useTheme()

  const styles = useStyles(theme, isTablet)

  return (
    <KeyboardView>
      <View style={[styles.form,
        isTablet && { flex: 1 }
      ]}
      >
        <Formik
          initialValues={{ email: '' }}
          onSubmit={(values, _) => onForgotPassword(values)}
          validationSchema={validationSchema}
        >
          {({ setFieldValue, handleSubmit, values, errors, touched }) => (
            <View>
              <Txt
                style={styles.text}
                Key='forgotPasswordSubtitle1'
                text='Please enter your email address.We will send you an email to reset your password.'
                identity='body2'
              />
              <InputFormik
                name='email'
                placeholder='Email'
                letfIcon='User'
                onChange={setFieldValue}
                value={values.email}
                error={touched.email && errors.email}
                keyboardType='email-address'
                testID='forgotPasswordEmailInput'
                accessibilityLabel='forgotPasswordEmailInput'
              />
              <Button
                title='Recover password'
                loading={loading}
                onPress={handleSubmit}
                style={styles.button}
                testID='forgotPasswordButton'
                accessibilityLabel='forgotPasswordButton'
              />
            </View>
          )}
        </Formik>
      </View>
    </KeyboardView>
  )
}

const useStyles = (theme, isTablet) => StyleSheet.create({
  form: {
    width: '100%',
    maxWidth: isTablet ? 350 : 'auto',
    marginHorizontal: 'auto',
    padding: 20,
    height: isTablet ? '100%' : 'auto',
    minHeight: 250,
    justifyContent: 'space-between',
    backgroundColor: theme.WHITE
  },
  text: {
    textAlign: 'center',
    marginVertical: 20
  },
  input: {
    marginBottom: 20
  },
  button: {
    width: '100%'
  }
})

ForgotPasswordForm.propTypes = {
  loading: PropTypes.bool,
  onForgotPassword: PropTypes.func.isRequired
}

ForgotPasswordForm.defaultProps = {
  loading: false,
  onForgotPassword: () => {}
}

export default ForgotPasswordForm
